
export interface OrganizationType {
    value: 'donor' | 'non_profit' | 'consulting_org' | 'other' | '';
    label: string;
}

export const organizationTypes: OrganizationType[] = [
    { value: 'donor', label: 'Donor' },
    { value: 'non_profit', label: 'Non Profit' },
    { value: 'consulting_org', label: 'Consulting Org' },
    { value: 'other', label: 'Other' }
];